export function isGzip(b: Uint8Array): boolean {
  return b.length >= 2 && b[0] === 0x1f && b[1] === 0x8b;
}

/**
 * Some object stores serve gzip bodies without `Content-Encoding`, so fetch() does not inflate
 * them. Inflate when the magic bytes are present; otherwise return the input unchanged.
 */
export async function maybeGunzip(b: Uint8Array): Promise<Uint8Array> {
  if (!isGzip(b)) return b;
  const stream = new Blob([b as BlobPart]).stream().pipeThrough(new DecompressionStream('gzip'));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}
